import { useMutation } from '@tanstack/react-query';
import { PersonalSchedule } from '#types/schedule';
import { post } from '../libs';

/**
 * 코치 - 개인일정 추가
 */
export function usePostPersonalScheduleMutaion() {
  return useMutation((payload: PersonalSchedule) =>
    post<string, PersonalSchedule>(`/schedules/coach/personal`, payload)
  );
}
